// Angular
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';

// RxJS
import { catchError, map, of } from 'rxjs';

// Local
import { JudgeChambersApiService } from '@app/services/api/judge-chambers/judge-chambers-api.service';
import { ErrorsStateService } from '@app/services/ui-state/errors-state/errors-state.service';
import {
  EMPTY_JUDGE_CHAMBERS_VIEW,
  JudgeChambersView,
} from './models/judge-chambers-view.model';
import { mapJudgeChambersSummary } from './services/map-judge-chambers.utils';

/**
 * Pre-loads the chamber data (tags, unread notification count) for the Judge
 * Chambers page, mapped to its UI model. The queue itself still loads through
 * `judgeReviewListResolver`, so a chamber data failure degrades to no tags and
 * no notifications rather than blocking the queue.
 */
export const judgeChambersListResolver: ResolveFn<JudgeChambersView> = () => {
  const judgeChambersApiService = inject(JudgeChambersApiService);
  const errorsStateService = inject(ErrorsStateService);

  return judgeChambersApiService.getJudgeChambersSummary().pipe(
    map(mapJudgeChambersSummary),
    catchError(err => {
      console.error(
        'An error occurred while fetching judge chambers data.',
        err,
      );
      errorsStateService.showError(
        'Judge chambers tags and notifications could not be loaded.',
      );
      return of(EMPTY_JUDGE_CHAMBERS_VIEW);
    }),
  );
};
